import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import Bugsnag from '@bugsnag/js';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { environment } from '@meplis/environments';

/**
 * Started on idle rather than before bootstrap: Bugsnag's session/trace calls
 * (sessions.bugsnag.com, otlp.bugsnag.com) open a cold third-party connection
 * that otherwise competes with the app's own chunks and fonts for bandwidth on
 * the critical path. AppErrorHandler guards with `Bugsnag.isStarted()`, so
 * error and performance tracking stay intact -- they just start slightly later.
 */
function startBugsnag(): void {
  if (!environment.bugsnagApiKey) return;
  Bugsnag.start({ apiKey: environment.bugsnagApiKey });
  BugsnagPerformance.start({ apiKey: environment.bugsnagApiKey });
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(() => startBugsnag());
    } else {
      setTimeout(startBugsnag, 0);
    }
  })
  .catch((err) => console.error(err));
